import { Button, DatePicker, Label, Text } from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import { SaleOrderProps } from '@/types'

import type { OrderShipmentDeliveyAtFormProps } from './order-shipment-delivery-at-form.type'

import styles from './order-shipment-delivery-at-form.module.css'
import { useValidationErrors } from '@/helpers'
import { schemaOrderDeliveryAt } from './order-shipment-delivery-at-form.constants'
import { useEffect, useState } from 'react'

export const OrderShipmentDeliveyAtForm = ({
  onChangeValues,
  values,
  onBack,
  onHandleSubmit,
}: OrderShipmentDeliveyAtFormProps) => {
  const { t } = useTranslation('componentsOrderShipmentDeliveyAtForm')

  const { isValid, errors, onHandleListenErrors } = useValidationErrors(
    schemaOrderDeliveryAt(t),
    values,
  )

  const [deliveredAtLast, setDeliveredAtLast] = useState<string[]>([])

  const onHandleSubmitLocal = () => {
    if (!isValid) {
      onHandleListenErrors(true)
      return
    }

    onHandleListenErrors(false)
    onHandleSubmit()
  }

  const onHandleValuesArray = (
    objectIndex: number,
    attributeKey: keyof SaleOrderProps[keyof SaleOrderProps],
    value?: string | number | boolean,
  ) => {
    const originalArray = Array.isArray(values?.shipments)
      ? values?.shipments
      : []

    const updatedArray = [...(originalArray as any[])] // eslint-disable-line

    updatedArray[objectIndex] = {
      ...updatedArray[objectIndex],
      [attributeKey]: value,
    }

    onChangeValues({ ...values, shipments: updatedArray })
  }

  useEffect(() => {
    values?.shipments?.forEach((shipment) => {
      setDeliveredAtLast((prev) => [...prev, shipment?.deliveredAt])
    })
  }, [values])

  return (
    <>
      <div className={styles.core}>
        {values?.shipments?.map((shipment, index) => (
          <div key={shipment.uuid} className={styles.content}>
            <Text variant="text-large-bold">{`${t('subtitle')} ${index + 1}`}</Text>
            <div>
              <Label>{t('deliveryAtLastLabel')}</Label>
              <DatePicker
                placeholder={'dd/mm/yyyy'}
                value={deliveredAtLast?.[index] || undefined}
                disabled
              />
            </div>

            <div>
              <Label>
                {t('deliveryAtNewLabel')}
                <span className={styles.required}>*</span>
              </Label>
              <DatePicker
                placeholder={'dd/mm/yyyy'}
                value={shipment?.deliveredAt}
                onChange={(newValue) =>
                  onHandleValuesArray(
                    index,
                    'deliveredAt' as keyof SaleOrderProps[keyof SaleOrderProps],
                    newValue,
                  )
                }
                error={
                  (errors?.[`shipments[${index}]`] as Record<string, string>)
                    ?.deliveredAt
                }
              />
            </div>
          </div>
        ))}
      </div>

      <div className={styles.footer}>
        <Button variant="secondary" onClick={onBack}>
          {t('buttonCancel')}
        </Button>

        <Button onClick={onHandleSubmitLocal}>{t('buttonSubmit')}</Button>
      </div>
    </>
  )
}
